import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Profile from "./pages/profile/Profile";
import Earnings from "./pages/earnings/earnings"


export default function App() {



  return (
    // <div className="App">
    //   {token} loading a page
    // </div>
    <>
      <BrowserRouter>
        {/* <nav>
          <NavLink to="/">Profile</NavLink>
          <NavLink to="/earnings">Earnings</NavLink>
        </nav> */}
        <Routes>
          <Route path="/" element={<Profile />} />
          <Route path="/earnings" element={<Earnings />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

